let __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (let s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i]
            for (const p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p]
        }
        return t
    }
    return __assign.apply(this, arguments)
}

Object.defineProperty(exports, "__esModule", { value: true })
exports.AncestorChart = exports.getAncestorsTree = void 0

const chart_util_1 = require("./chart-util")
const d3_hierarchy_1 = require("d3-hierarchy")
const id_generator_1 = require("./id-generator")


function getAncestorsTree(options) {
    const ancestorChartOptions = __assign({}, options)
    const startIndiFamilies = options.startIndi ? options.data.getIndi(options.startIndi).getFamiliesAsSpouse() : []
    // If the start individual is set and this person has at least one spouse, start with the family instead
    if (startIndiFamilies.length) {
        ancestorChartOptions.startFam = startIndiFamilies[0]
        ancestorChartOptions.startIndi = undefined
        const fam = options.data.getFam(startIndiFamilies[0])
        if (fam.getMother() === options.startIndi)
            ancestorChartOptions.swapStartSpouses = true
    }
    const ancestors = new AncestorChart(ancestorChartOptions)
    const ancestorsRoot = ancestors.createHierarchy()
    // Remove spouse's ancestors if there are multiple spouses to avoid showing ancestors of just one spouse.
    if (startIndiFamilies.length > 1 &&
        ancestorsRoot.children &&
        ancestorsRoot.children.length > 1) {
        ancestorsRoot.children.pop();
        ancestorsRoot.data.spouseParentNodeId = undefined
    }
    return ancestorsRoot
}
exports.getAncestorsTree = getAncestorsTree

/** Renders an ancestors chart. */
const AncestorChart = (function () {

    function AncestorChart(options) {
        this.options = options
        this.util = new chart_util_1.ChartUtil(options)
    }

    /** Creates a d3 hierarchy from the input data. */
    AncestorChart.prototype.createHierarchy = function () {
        let id
        let famc
        let indi
        const parents = []
        const stack = []
        const visitedFamIds = new Set()
        const idGenerator = this.options.idGenerator || new id_generator_1.IdGenerator()

        if (this.options.startIndi) {
            indi = this.options.data.getIndi(this.options.startIndi)
            famc = indi.getFamilyAsChild()
            id = famc ? idGenerator.getId(famc) : undefined
            if (famc && !visitedFamIds.has(famc)) {
                visitedFamIds.add(famc)
                stack.push({ id: famc, parentId: this.options.startIndi, family: { id: famc } })
            }
            parents.push({ id: this.options.startIndi, indi: { id: this.options.startIndi }, indiParentNodeId: id })
        }
        else {
            const startFamId = this.options.startFam
            if (startFamId && !visitedFamIds.has(startFamId)) {
                visitedFamIds.add(startFamId)
                stack.push({ id: idGenerator.getId(startFamId), family: { id: startFamId } })
            }
        }

        while (stack.length) {
            const entry = stack.pop();
            const fam = this.options.data.getFam(entry.family.id)
            if (!fam) continue

            const _a = entry.family.id === this.options.startFam && this.options.swapStartSpouses
                ? [fam.getMother(), fam.getFather()]
                : [fam.getFather(), fam.getMother()],
                father = _a[0],
                mother = _a[1]

            if (!father && !mother) continue

            if (mother) {
                entry.spouse = { id: mother }
                indi = this.options.data.getIndi(mother)
                famc = indi.getFamilyAsChild()
                if (famc && !visitedFamIds.has(famc)) {
                    id = idGenerator.getId(famc)
                    entry.spouseParentNodeId = id
                    visitedFamIds.add(famc)
                    stack.push({ id: id, parentId: entry.id, family: { id: famc } })
                }
            }
            if (father) {
                entry.indi = { id: father }
                indi = this.options.data.getIndi(father)
                famc = indi.getFamilyAsChild()
                if (famc && !visitedFamIds.has(famc)) {
                    id = idGenerator.getId(famc)
                    entry.indiParentNodeId = id
                    visitedFamIds.add(famc)
                    stack.push({ id: id, parentId: entry.id, family: { id: famc } })
                }
            }
            parents.push(entry)
        }

        return d3_hierarchy_1.stratify()(parents)
    }

    /**
     * Renders the tree, calling the provided renderer to draw boxes for individuals.
     */
    AncestorChart.prototype.render = function () {
        const root = this.createHierarchy()
        const nodes = this.util.layOutChart(root, { flipVertically: true })
        const animationPromise = this.util.renderChart(nodes)
        const info = chart_util_1.getChartInfo(nodes)
        this.util.updateSvgDimensions(info)
        return Object.assign(info, { animationPromise: animationPromise })
    }

    return AncestorChart
}())
exports.AncestorChart = AncestorChart